// The shared resolver also handles section-rendered and dynamically added tokens.
window.ScandivvShipping?.render();
